import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common_en from './translations/en/common.json';
import common_es from './translations/es/common.json';
import common_pt from './translations/pt/common.json';

// resources
const resources = {
  es: { translation: common_es, },
  pt: { translation: common_pt, },
  en: { translation: common_en, },
};

// Detecta idioma do navegador para inicialização do i18next
const detectInitialLang = (): string => {
  const supportedLangs = Object.keys(resources);

  try {
    const stored = window.localStorage.getItem('novainfrainvest_lang');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.lang && supportedLangs.includes(parsed.lang)) {
        return parsed.lang;
      }
    }
  } catch {}

  const browserLangs = navigator.languages ?? [navigator.language];
  for (const browserLang of browserLangs) {
    const langCode = browserLang.split('-')[0].toLowerCase();
    if (supportedLangs.includes(langCode)) {
      return langCode;
    }
  }

  return 'es';
};

// options
const options = {
  resources,
  lng: detectInitialLang(),
  fallbackLng: ['es', 'pt', 'en']
};

// locales
const locales = Object.keys(options.resources);

// get current locate
const getCurrentLocale = () => i18n.languages.find((lng => locales.indexOf(lng) !== -1));

i18n
  .use(initReactI18next)
  .init(options);

export { i18n, locales, getCurrentLocale };
export default i18n;